import { addSearchFilter, createUserOpt } from "../general/elements/tables.js";
import {
  addSpinner,
  getEndDate,
  getStartDate,
  getUser,
  removeSpinner,
  urlParams,
  wrappedGet,
  wrappedPost,
} from "../general/utils";
import { showToast, yesNoConfirm, teamHasDialler } from "@sourcewhale/core";
import {
  addColumnHeadTooltips,
  augmentEvent,
  displayCallsFunnel,
  displayCandidateChart,
  displayCandidateTable,
  displayDiallerActivityTable,
  displayTeamActivityTable,
  displayTeamChart,
  REPORT_PROPERTIES,
  selectedReportFilters,
  selectedReportFiltersArray,
  setRowVisibilities,
} from "../general/report-utils.js";

const DATA = {
  events: [],
  allSourcers: [],
  initialOutreach: [],
  followupOutreach: [],
};

const displayTables = () => {
  displayCandidateTable(DATA);
  displayTeamActivityTable(DATA);
  if (teamHasDialler(false)) {
    displayDiallerActivityTable(DATA);
  }
  addColumnHeadTooltips();
};

const displaySelectorCounts = () => {
  const values = selectedReportFilters();
  $(".selected-counts").remove();
  selectedReportFiltersArray.forEach((item) => {
    const arrayKey = Object.keys(item);
    const arrayVal = Object.values(item);
    const selected = values[arrayVal].length;
    const num = arrayKey[0] === "teamGroup" ? +(selected > 0) : selected;
    if (num > 0) {
      $(`[data-id="${arrayKey}Selector"]`).append(
        `<span class="selected-counts badge badge-warning">${num}</span>`,
      );
    }
  });
};

const displayCharts = () => {
  displayCandidateChart(DATA);
  displayTeamChart(DATA);
  if (teamHasDialler(false)) {
    displayCallsFunnel(DATA);
  }
  displayTables();
  displaySelectorCounts();
};

const updateReports = () => {
  const from = getStartDate("#reportsDatepickerInput");
  const to = getEndDate("#reportsDatepickerInput");

  if (!(from && to)) return;

  $(".chartCard, .tableCard, #top-container").addClass("skeleton-loading");

  wrappedGet({
    url: "/api/reports/query",
    data: { to, from },
    success: (res) => {
      DATA.events = res.events;
      DATA.calls = res.calls;

      REPORT_PROPERTIES.teamGroupsDict = res.teamGroupsDict;
      REPORT_PROPERTIES.campaignDict = res.campaignDict;

      DATA.events.forEach(augmentEvent);
      DATA.calls.forEach(augmentEvent);
      DATA.allSourcers = res.sourcers;

      const addCampaignType = (outreach) => {
        if (outreach.campaignId) {
          const { campaignType } =
            REPORT_PROPERTIES.campaignDict[outreach.campaignId] || {};
          outreach.campaignType = campaignType;
        }
        return outreach;
      };

      DATA.initialOutreach = res.sentOutreach
        .filter((x) => x.isInitialOutreach === "initial")
        .map(addCampaignType);

      DATA.followupOutreach = res.sentOutreach
        .filter((x) => x.isInitialOutreach === "followUp")
        .map(addCampaignType);

      displayCharts();

      ["sourcers", "senders", "campaigns", "projects", "tags"].forEach(
        (key) => {
          const selector = $(`#${key}Selector`);
          const currentValue = selector.selectpicker("val");
          selector.find("option").remove();
          selector.parent().removeClass("disabled permanent-disabled");
          const items = res[key].sort((a, b) =>
            key === "sourcers"
              ? (a.status === "deleted") - (b.status === "deleted")
              : 0,
          );

          items.forEach((item) => {
            if (key === "sourcers") {
              const multi =
                items.filter((y) => y.text === item.text).length > 1;
              selector.append(
                $("<option>", createUserOpt(item, item.text, multi)),
              );
            } else selector.append($("<option>", item));
          });

          if (!res[key].length)
            selector.parent().addClass("disabled permanent-disabled");

          selector.selectpicker("refresh");
          selector.selectpicker("val", currentValue);

          if (key === "sourcers")
            selector.addClass("sourcer-selector").selectpicker("setStyle");
        },
      );

      $(".chartCard, #top-container").removeClass("skeleton-loading");
    },
    error: () => {
      $(".chartCard, #top-container").removeClass("skeleton-loading");
    },
  });
};

const resetDropdownToDefaults = () => {
  const from = moment().subtract(29, "days");
  const to = moment();
  $("#reportsDatepickerInput").data("daterangepicker").setStartDate(from);
  $("#reportsDatepickerInput").data("daterangepicker").setEndDate(to);
  $("#periodSelector").selectpicker("val", "weeks");
  $("#candidateStatsGroupBySelector").selectpicker("val", "time");
  $(".breakdownSelector").selectpicker("val", "none");
  $(".campaignVisibilitySelector").selectpicker("val", ["open"]);
  $(".campaignVisibilitySelectorWrapper").toggle(false);
};

const resetReportFilters = () => {
  const $searchFilters = $("#searchFilters");
  const $resetButton = $("#resetReportFiltersBtn");

  $searchFilters.find("select.selectpicker").each((_, element) => {
    $(element).val("").selectpicker("refresh");
  });

  $("#teamGroupSelector").val("").selectpicker("refresh").trigger("change");

  $resetButton.hide();
  $searchFilters.trigger("change");
};

const checkActiveFilters = () => {
  const $selectors = $("#searchFilters select.selectpicker");
  return $selectors
    .toArray()
    .some((selector) => $(selector).val() && $(selector).val().length > 0);
};

const initializeReportFilters = () => {
  $("#resetReportFiltersBtn").on("click", resetReportFilters);

  $("#searchFilters").on("change", () => {
    $("#resetReportFiltersBtn").toggle(checkActiveFilters());
  });

  $("#resetReportFiltersBtn").toggle(checkActiveFilters());
};

let REPORTS = [];
let SELECTED_REPORT_ID;

const resetReports = () => {
  resetDropdownToDefaults();

  $("#savedReportsDropdown").selectpicker("val", "");
  $(".report-check").hide();
  $(".dropdown-item").removeClass("active-report");

  $("#reportNameWrapper").hide();
  $("#reportName").text("");
  $("#createdAt").text("");

  SELECTED_REPORT_ID = null;
};

const fillSavedReportsDropdown = () => {
  $("#savedReportsDropdown").parent().removeClass("disabled");

  wrappedGet({
    url: "/api/reports/get_all",
    success: (res) => {
      REPORTS = res.reports;

      if (!res.reports.length) {
        $("#savedReportsDropdown").parent().addClass("disabled");
        return;
      }

      res.reports.sort((a, b) => b.createdAt - a.createdAt);

      $("#savedReportsDropdown").empty();

      res.reports.forEach((savedReport) => {
        const id = savedReport.reportId;

        $("#savedReportsDropdown").append(/* html */ `
            <div id="${id}SavedReport" class="d-flex align-items-center">
              <div id="${id}LoadSavedReportButton" class='dropdown-item' data-id="${id}"><i style="color: #359bd7;display:none;" id="${id}Check" class="report-check fas fa-check"></i> ${savedReport.reportName}</div>
              <i id="${id}DeleteSavedReportButton" class="saved-report-button fa-regular fa-trash-can ml-3"></i>
            </div>
          `);

        $(`#${id}LoadSavedReportButton`).click(() => {
          resetDropdownToDefaults();

          const { search, groupings } = savedReport;

          selectedReportFiltersArray.forEach((x) => {
            const selector = Object.keys(x)[0];
            const property = x[selector];

            if (selector === "sourcers" && search.groupId) {
              const teamGroup = getUser().teamGroups[search.groupId];
              $(`#${selector}Selector`).selectpicker("val", teamGroup.users);
            } else {
              $(`#${selector}Selector`).selectpicker("val", search[property]);
            }
          });

          const selectorMapping = {
            campaignVisibility: "candidateStatsCampaignVisibility",
            groupBy: "candidateStatsGroupBy",
            breakdown: "candidateStatsBreakdown",
            diallerGroupBy: "diallerActivityGroupBy",
            diallerBreakdown: "diallerActivityBreakdown",
            diallerCampaignVisibility: "diallerActivityCampaignVisibility",
          };

          Object.entries(groupings).forEach(([selector, property]) => {
            selector = selectorMapping[selector] || selector;
            $(`#${selector}Selector`).selectpicker("val", property);
          });

          $(".selectpicker").selectpicker("refresh");
          SELECTED_REPORT_ID = id;

          $("#reportNameWrapper").show();
          $("#reportName").text(savedReport.reportName);

          const formattedDate = new Date(
            savedReport.createdAt * 1000,
          ).toDateString();
          $("#createdAt").text(`Created ${formattedDate}`);

          updateReports();

          $(".report-check").hide();
          $(".dropdown-item").removeClass("active-report");
          $(`#${id}Check`).show();
          $(`#${id}LoadSavedReportButton`).addClass("active-report");
          $(".active-report").click(() => {
            document.location.reload();
          });
        });

        $(`#${id}DeleteSavedReportButton`).click((e) => {
          e.stopPropagation();

          const deleteReport = () => {
            addSpinner(`#${id}SavedReport`);
            $(`#${id}SavedReport .delete-saved-report-button`).remove();
            wrappedPost({
              url: "/api/reports/delete",
              data: JSON.stringify({ reportId: id }),
              success: () => {
                $(`#${id}SavedReport`).remove();
                if ($("#savedReportsDropdown").children().length === 0) {
                  $("#savedReportsDropdown").parent().addClass("disabled");
                  $("#savedReportsDropdown").dropdown("toggle");
                }
              },
            });
          };

          yesNoConfirm(
            `Are you sure you want to delete the report ${savedReport.reportName}?`,
            deleteReport,
            "",
            "Delete",
            "Cancel",
          );
        });
      });
    },
  });
};

export const initializeReports = () => {
  const tab = urlParams.get("tab");
  if (tab) {
    const $nav = $(`#${tab}ActivityTab`);
    if ($nav.length) $nav.click();
  }

  if (!getUser().hideCampaignTypes) {
    $(
      '#campaignTypeSelectorContainer, .breakdownSelector option[value="campaignType"]',
    ).show();
  }

  [
    "sourcers",
    "senders",
    "campaigns",
    "campaignType",
    "projects",
    "tags",
    "candidateCountry",
  ].forEach((key) => {
    $(`#${key}Selector`).change((e) => {
      if (key === "sourcers" && !e.isTrigger) {
        $("#teamGroupSelector").selectpicker("val", "");
      }
      displayCharts();
    });
  });

  $("#teamGroupSelector").change((e) => {
    const id = $(e.currentTarget).val();

    if (id === "_all") {
      $("#sourcersSelector").val([]).selectpicker("refresh");
    } else if (id) {
      const userIds = getUser().teamGroups[id]?.users || [];
      $("#sourcersSelector").val(userIds).selectpicker("refresh");
    } else {
      $("#sourcersSelector").val([]).selectpicker("refresh");
    }

    $("#sourcersSelector").trigger("change");
  });

  $("#clearReportButton").on("click", () => {
    resetReports();
    updateReports();
  });

  updateReports();

  $("#reportsDatepickerInput").on("apply.daterangepicker", () =>
    updateReports(),
  );

  $("#periodSelector").selectpicker("refresh");

  $("#periodSelector").change(() => displayCharts());

  ["candidateStats", "diallerActivity"].forEach((table) => {
    $(`#${table}CampaignVisibilitySelector`).change((e) => {
      const statuses = $(e.currentTarget).selectpicker("val");
      setRowVisibilities(`#${table}Table`, statuses);
    });
  });

  $(".groupBySelector, .breakdownSelector").change(displayTables);

  $("#candidateStatsTableDownloadButton").click(() => {
    const candidateStatsTable = $("#candidateStatsTable").DataTable();
    candidateStatsTable.button(0).trigger();
  });

  $("#teamActivityTableDownloadButton").click(() => {
    const teamActivityTable = $("#teamActivityTable").DataTable();
    teamActivityTable.button(0).trigger();
  });

  $("#diallerActivityTableDownloadButton").click(() => {
    const diallerActivityTable = $("#diallerActivityTable").DataTable();
    diallerActivityTable.button(0).trigger();
  });

  $("#openSaveReportModalButton").click(() => {
    $("#saveReportModal").modal("show");
  });

  $('[data-toggle="tooltip"]').on("click", (e) => {
    $(e.currentTarget).tooltip("dispose");
  });

  $(`#shareReportButton`).click(() => {
    const reportTabs = $("#reportTabsNav");
    const currentTab = reportTabs.find(".nav-link.active").attr("data-id");
    $("#shareReportTabSelector").selectpicker("val", currentTab);
    $("#shareModal").modal("show");
    $("#modalShareButton").html("Create Link <i class='fas fa-link ml-2'></i>");
    $("#shareModalName").val($("#reportName").text());
  });

  fillSavedReportsDropdown();
  initializeReportFilters();

  $("#shareModalExpiryInput")
    .data("daterangepicker")
    .setStartDate(moment().add(1, "M"));

  $("#modalShareButton").click(() => {
    const name = $("#shareModalName").val();
    const from = new Date(getStartDate("#reportsDatepickerInput"));
    const to = new Date(getEndDate("#reportsDatepickerInput"));
    const period = $("#periodSelector").val();
    const group = $("#candidateStatsGroupBySelector").val();
    const diallerGroup = $("#diallerActivityGroupBySelector").val();
    const breakdown = $("#candidateStatsBreakdownSelector").val();
    const teamActivityBreakdown = $("#teamActivityBreakdownSelector").val();
    const diallerBreakdown = $("#diallerActivityBreakdownSelector").val();
    const campaignStatuses = $(
      "#candidateStatsCampaignVisibilitySelector",
    ).val();
    const teamActivityCampaignStatuses = $(
      "#teamActivityCampaignVisibilitySelector",
    ).val();
    const diallerCampaignStatuses = $(
      "#diallerActivityCampaignVisibilitySelector",
    ).val();
    const expiry = new Date(getStartDate("#shareModalExpiryInput"));
    const reportTabs = $("#shareReportTabSelector").selectpicker("val");

    if (!name.length) {
      showToast({
        title: "Please enter a name for the report",
        type: "warning",
      });
      return;
    }

    if (!reportTabs.length) {
      showToast({
        title: "Please select at least one tab to share",
        type: "warning",
      });
      return;
    }

    addSpinner("#modalShareButton");

    wrappedPost({
      url: "/api/shared/create",
      data: JSON.stringify({
        kind: "report",
        reportId: SELECTED_REPORT_ID,
        name,
        from,
        to,
        expiry,
        reportTabs,
        groupings: {
          group,
          diallerGroup,
          breakdown,
          teamActivityBreakdown,
          diallerBreakdown,
          campaignStatuses,
          teamActivityCampaignStatuses,
          diallerCampaignStatuses,
          period,
        },
      }),
      success: (res) => {
        removeSpinner("#modalShareButton");
        navigator.clipboard.writeText(res.url).then(() => {
          $("#modalShareButton").html(
            'Copied to Clipboard<i class="fas fa-check-circle ml-2"></i>',
          );
        });
      },
      error: () => {
        removeSpinner("#modalShareButton");
      },
    });
  });

  $("#saveReportsButton").click(() => {
    const reportsName = $("#reportNameInput").val();

    const reportNames = REPORTS.map((report) => report.reportName);

    if (reportsName.trim().length === 0) {
      showToast({
        title: "Please enter a name for the report",
        type: "warning",
      });
      return;
    }

    if (reportNames.includes(reportsName)) {
      showToast({
        title: "A report with this name already exists",
        type: "warning",
      });
      return;
    }

    $("#saveReportModal").modal("hide");

    const search = selectedReportFilters();
    if (search.groupId) search.sourcerUserIds = [];

    const groupings = {
      groupBy: $("#candidateStatsGroupBySelector").val(),
      diallerGroupBy: $("#diallerActivityGroupBySelector").val(),
      breakdown: $("#candidateStatsBreakdownSelector").val(),
      teamActivityBreakdown: $("#teamActivityBreakdownSelector").val(),
      diallerBreakdown: $("#diallerActivityBreakdownSelector").val(),
      campaignVisibility: $("#candidateStatsCampaignVisibilitySelector").val(),
      teamActivityCampaignVisibility: $(
        "#teamActivityCampaignVisibilitySelector",
      ).val(),
      diallerCampaignVisibility: $(
        "#diallerActivityCampaignVisibilitySelector",
      ).val(),
      period: $("#periodSelector").val(),
    };

    wrappedPost({
      url: "/api/reports/save",
      data: JSON.stringify({
        reportName: reportsName,
        search,
        groupings,
      }),
      success: (res) => {
        fillSavedReportsDropdown();
        $("#reportNameInput").val("");

        $("#reportNameWrapper").show();
        $("#reportName").text(reportsName);

        const formattedDate = new Date().toDateString();
        $("#createdAt").text(`Created ${formattedDate}`);
        showToast({
          title: "Report saved successfully",
          type: "success",
        });

        SELECTED_REPORT_ID = res.reportId;
      },
      spinner: "#saveReportsButton",
    });
  });

  addSearchFilter();
};
